import {Formik, Form} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import toast from 'react-hot-toast'
import {createBus, updateBus} from './api'
import {handleApiError} from '../../../helpers/errorHandler'
import {useQuery} from 'react-query'
import {fetchBusBrandList} from '../busBrand/api'
import {RunnerBall} from '../../../components/FormLoader'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'
import {Col, Row} from 'react-bootstrap'

function BusForm({initialValues, onAfterSubmit}) {
  const formType = initialValues ? 'update' : 'add'

  const {data: busBrands, isLoading} = useQuery('busBrandList', fetchBusBrandList, {
    refetchOnWindowFocus: false,
  })

  const submitHandler = (values, {setSubmitting: setLoading}) => {
    setLoading(true)
    const toastId = toast.loading('Submitting')
    const action = formType === 'add' ? createBus : updateBus
    values.bus_insurance_expiry =
      values.bus_insurance_expiry === '' ? '0001-01-01' : values.bus_insurance_expiry
    values.bus_last_service =
      values.bus_last_service === '' ? '0001-01-01' : values.bus_last_service
    values.bus_polution_expiry =
      values.bus_polution_expiry === '' ? '0001-01-01' : values.bus_polution_expiry
    action(values)
      .then(() => {
        toast.success('Success', {id: toastId})
        onAfterSubmit()
      })
      .catch((err) => {
        handleApiError(err, toastId)
      })
      .then((res) => setLoading(false))
  }
  const formValues = initialValues || {
    bus_name: '',
    bus_status: '1',
    bus_number: '',
    bus_registration_number: '',
    bus_insurance_expiry: '',
    bus_polution_expiry: '',
    bus_last_service: '',
  }

  if (isLoading) {
    return <RunnerBall />
  }

  return (
    <div className="px-5 py-3">
      <Formik
        initialValues={formValues}
        validationSchema={Yup.object({
          bus_name: Yup.string()
            .max(100, 'The Bus Brand cannot exceed 100 characters')
            .required('Bus Brand is required'),
          bus_number: Yup.string().required('Bus number is required'),
          bus_seat_capacity: Yup.number()
            .min(10, 'Seat capacity should be minimum 10')
            .integer('Bus Seat Capacity must be an integer')
            .required('Bus Seat Capacity is required'),
          bus_registration_number: Yup.string().required('Bus Registration number is required'),
          // bus_insurance_expiry: Yup.date()
          //   .test('is-4-digit-year', 'Year must be a 4-digit number', (value) => {
          //     if (!value) return true
          //     const year = value.getFullYear()
          //     return year >= 1000 && year <= 9999
          //   })
          //   .min(startOfToday(), 'Insurance Expiry cannot be in the past'),

          // bus_polution_expiry: Yup.date()
          //   .test('is-4-digit-year', 'Year must be a 4-digit number', (value) => {
          //     if (!value) return true
          //     const year = value.getFullYear()
          //     return year >= 1000 && year <= 9999
          //   })
          //   .min(startOfToday(), 'Pollution Expiry cannot be in the past'),
          // bus_last_service: Yup.date()
          //   .test('is-4-digit-year', 'Year must be a 4-digit number', (value) => {
          //     if (!value) return true
          //     const year = value.getFullYear()
          //     return year >= 1000 && year <= 9999
          //   })
          //   .max(startOfToday(), 'Last service date cannot be in the future'),
          bus_status: Yup.string().required('Bus Status is required'),
        })}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, values, isValid, dirty}) => (
          <Form>
            <Row>
              <Col sm="6">
                <FormikControl
                  control={'select-advanced'}
                  options={busBrands.data}
                  placeholder="Bus Brand"
                  label="Bus Brand"
                  name="bus_name"
                  value={busBrands.data.find((brand) => brand.bus_type === values.bus_name) || ''}
                  optionLabel={'bus_type'}
                  optionValue={'bus_type'}
                  required
                />
              </Col>
              <Col sm="6">
                <FormikControl
                  control="input"
                  required
                  placeholder="Bus Number"
                  label="Bus Number"
                  name="bus_number"
                />
              </Col>
              <Col sm="6">
                <FormikControl
                  control="input"
                  required
                  placeholder="Bus Registration Number"
                  label="Bus Registration Number"
                  name="bus_registration_number"
                />{' '}
              </Col>
              <Col sm="6">
                <FormikControl
                  control="input"
                  type="number"
                  required
                  placeholder="Bus Seat Capacity"
                  label="Bus Seat Capacity"
                  name="bus_seat_capacity"
                />
              </Col>

              {/* <FormikControl
              control="input"
              type="date"
              placeholder="Insurance Expiry Date"
              label="Insurance Expiry Date"
              name="bus_insurance_expiry"
            /> 
            <FormikControl
              control="input"
              type="date"
              placeholder="Pollution Expiry Date"
              label="Pollution Expiry Date"
              name="bus_polution_expiry"
            />
            <FormikControl
              control="input"
              type="date"
              placeholder="Last Service Date"
              label="Last Service Date"
              name="bus_last_service"
            />*/}
              <Col sm="6">
                <FormikControl
                  control="check"
                  type="radio"
                  options={[
                    {key: 'Active', value: '1'},
                    {key: 'Inactive', value: '0'},
                  ]}
                  required
                  placeholder="Active Status"
                  label="Active Status"
                  name="bus_status"
                />{' '}
              </Col>
            </Row>
            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default BusForm
